var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"onboard-header"},[_c('div',{staticClass:"onboard-icon-wrapper"},[_vm._t("img")],2),_c('h4',{staticClass:"text-center header-text"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"subtitle text-center body-text"},[_vm._v(_vm._s(_vm.subtitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }